import abi from "./contract/DonateToCreator.json";
import {useState, useEffect} from 'react'; 
import {ethers} from "ethers"; 
import Donate from "./components/Donate";
import Donors from "./components/Donors";
import img from "./img.png"
import './App.css';

function App() {
  const [state, setState]= useState({
    provider:null, 
    signer:null, 
    contract:null 
  })
  const [account, setAccount] = useState("None");
  useEffect(()=>{
    const connectWallet=async()=>{
      const contractAddress = "0x4953e151942e0a3902a9061e64e1ddb6bb41783c"; 
      const contractABI = abi.abi;
      try{
        const {ethereum}=window; 
        if(ethereum){
          const account = await ethereum.request({method:"eth_requestAccounts",}); 

          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          const provider = new ethers.providers.Web3Provider(ethereum); 
          const signer = provider.getSigner(); 
          const contract = new ethers.Contract(contractAddress, contractABI, signer);
          setAccount(account); 
          setState({provider, signer, contract}); 
        }
        else{
          alert("Please install metamask"); 
        }
      }
      catch(error){
        console.log(error); 
      } 
    };
    connectWallet();  
  },[])
  // console.log(state); 
  return (
    <div style={{ backgroundColor: "#EFEFEF", height: "100%" }}>
    <img src={img} className="img-fluid" alt=".." width="100%" />
    <p class="text-muted lead " style={{ marginTop: "10px", marginLeft: "5px" }}>
    <small>Connected Account - {account}</small>
    </p>
    <div className="container">
      <Donate state={state}></Donate>
      <Donors state={state}></Donors>
      </div>
    </div>

  );
}

export default App;
